import React from 'react';
import {useTranslation} from 'react-i18next';

/**
 * Cuánto del cupo de cuentas del plan usa la cartera, en el pie.
 *
 * Se muestra desde que hay algo elegido, y no recién al pasarse: enterarse del tope cuando ya no
 * entra obliga a deshacer, y verlo venir deja elegir con criterio. Pasado el cupo dice cuántas
 * sobran —es la acción concreta— y es lo que explica por qué el primario está gris.
 *
 * Dice las DOS unidades, clientes y cuentas, porque el botón de al lado cuenta clientes y el cupo
 * se mide en cuentas: con una sola —«usa 7 de las 70»— se leía como el mismo número que el botón
 * (card 2yINyKQv). Cada número lleva su propio plural (`client_count`, `ad_account_count`): i18next
 * pluraliza por un solo `count`, y el de la frase es lo que queda del cupo.
 */
export function QuotaNote({quota}) {
    const {t} = useTranslation();
    if (!quota || quota.needed === 0) return null;

    if (quota.over > 0) {
        return (
            <span className="ob-note -over" role="status">
                {t('onboarding.clients.quota_over', {count: quota.over, limit: quota.limit, used: quota.used})}
            </span>
        );
    }
    return (
        <span className="ob-note">
            {t('onboarding.clients.quota_usage', {
                count: quota.left,
                limit: quota.limit,
                clients: t('onboarding.clients.client_count', {count: quota.clients}),
                accounts: t('onboarding.clients.ad_account_count', {count: quota.needed}),
                interpolation: {escapeValue: false},
            })}
        </span>
    );
}
